var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKuroLogoFullAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 368.018,
    height: 161.992,
    viewBox: "0 0 368.018 161.992",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Exclusion_25",
    x: 190.012,
    y: 72.267,
    width: 97.006,
    height: 54.82,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Exclusion_26",
    x: 271.137,
    y: 72.267,
    width: 96.88,
    height: 54.819,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_2025",
    x: 0,
    y: 0,
    width: 145.187,
    height: 158.363,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-3"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-3"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_2026",
    x: 64.391,
    y: 50.607,
    width: 89.081,
    height: 111.386,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-4"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-4"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_2452",
    x: 119.576,
    y: 72.266,
    width: 89.632,
    height: 54.819,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-5"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-5"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_631",
    "data-name": "Group 631",
    transform: "translate(-650.984 -592.515)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_630",
    "data-name": "Group 630"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 650.98, 592.51)",
    filter: "url(#Exclusion_25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Exclusion_25-2",
    "data-name": "Exclusion 25",
    d: "M-452.066-11053.18H-467l5.6-29.5a5.614,5.614,0,0,1,1.241-2.461,10.968,10.968,0,0,1,2.8-2.1,10.072,10.072,0,0,1,3.749-1.4,15.171,15.171,0,0,1,4.044-.364h50.728a16.537,16.537,0,0,1,4.366.364,8.6,8.6,0,0,1,3.1,1.4,5.943,5.943,0,0,1,1.862,2.1l.028.065a3.149,3.149,0,0,1,.267,2.4l-1.859,10.541a5.634,5.634,0,0,1-1.241,2.461,11.025,11.025,0,0,1-2.8,2.095,10.059,10.059,0,0,1-3.746,1.4,15.186,15.186,0,0,1-4.044.364h-5.9l14.311,12.639-18.06,0-14.933-12.641h-22.292l-2.29,12.641Zm5.291-27.636h0l-1.177,7.416h46.011l1.353-7.416h-46.186Z",
    transform: "translate(666.61 11167.77)",
    fill: "#f8f9fa",
    stroke: "#707070",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 650.98, 592.51)",
    filter: "url(#Exclusion_26)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Exclusion_26-2",
    "data-name": "Exclusion 26",
    d: "M-405.432-11053.181h-51.429a16.493,16.493,0,0,1-4.375-.364l-.241-.07a10.066,10.066,0,0,1-3.187-1.327,2.012,2.012,0,0,0-.161-.122l-.008-.006c-.05-.036-.1-.073-.154-.117l-.076-.058a3.38,3.38,0,0,1-1.491-1.823,3.223,3.223,0,0,1-.323-2.463l4.4-23.148a5.939,5.939,0,0,1,1.241-2.461,11,11,0,0,1,2.808-2.1,9.627,9.627,0,0,1,3.754-1.4,15.218,15.218,0,0,1,4.049-.364h51.454a16.493,16.493,0,0,1,4.375.364l.234.068a10.058,10.058,0,0,1,3.195,1.329,5.446,5.446,0,0,1,1.862,2.1l.028.065a3.141,3.141,0,0,1,.27,2.4l-4.375,23.179a5.964,5.964,0,0,1-1.241,2.463,10.964,10.964,0,0,1-2.808,2.1,9.591,9.591,0,0,1-3.751,1.4A15.218,15.218,0,0,1-405.432-11053.181Zm-40.9-27.223h0l-3.142,18.623h39.741l3.142-18.623Z",
    transform: "translate(747.61 11167.77)",
    fill: "#f8f9fa",
    stroke: "#707070",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_603",
    "data-name": "Group 603",
    transform: "translate(213.98 442.671)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 437, 149.84)",
    filter: "url(#Path_2025)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2025-2",
    "data-name": "Path 2025",
    d: "M87.136,7.963C89.9,6.369,124.4-1.022,126.239.12S31.97,129.914,28.377,133.254.394,140.7,0,138.948,84.384,9.563,87.136,7.963",
    transform: "translate(9.49 6.48)",
    fill: "#f8f9fa",
    stroke: "#707070",
    strokeWidth: 1,
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 437, 149.84)",
    filter: "url(#Path_2026)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2026-2",
    "data-name": "Path 2026",
    d: "M30.43,76.857c-1.07-2.9,15.993-24.878,15.993-24.878s19.905-26.252,22.5-27.663,16,1.172,15.575,3.6S56.838,63.9,61.19,72.417s39.883,43.06,39.351,43.828-28.763-4.152-30.5-5.2S31.5,79.761,30.43,76.857",
    transform: "translate(43.5 33.26)",
    fill: "#f8f9fa",
    stroke: "#707070",
    strokeWidth: 1,
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 650.98, 592.51)",
    filter: "url(#Path_2452)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2452-2",
    "data-name": "Path 2452",
    d: "M74.144,37.483H59.95L54.62,66.957a3.225,3.225,0,0,0,.306,2.458A3.274,3.274,0,0,0,56.413,71.3a1.226,1.226,0,0,1,.281.245,9.4,9.4,0,0,0,3.256,1.4A14.771,14.771,0,0,0,64.1,73.3h44.688a13.674,13.674,0,0,0,3.843-.367,9.291,9.291,0,0,0,3.562-1.4,10.478,10.478,0,0,0,2.665-2.094,5.8,5.8,0,0,0,1.178-2.458l5.021-29.474H110.863l-4.741,27.377H69.4Z",
    transform: "translate(74.56 41.28)",
    fill: "#f8f9fa",
    stroke: "#707070",
    strokeWidth: 1,
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_604",
    "data-name": "Group 604",
    transform: "translate(-2 2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_2453",
    "data-name": "Path 2453",
    transform: "translate(784 711)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.5,0h83a3.5,3.5,0,0,1,0,7H3.5a3.5,3.5,0,0,1,0-7Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 3.5 1 C 2.121498107910156 1 1 2.121500015258789 1 3.5 C 1 4.878499984741211 2.121498107910156 6 3.5 6 L 86.5 6 C 87.87850189208984 6 89 4.878499984741211 89 3.5 C 89 2.121500015258789 87.87850189208984 1 86.5 1 L 3.5 1 M 3.5 0 L 86.5 0 C 88.43299865722656 0 90 1.566999912261963 90 3.5 C 90 5.433000087738037 88.43299865722656 7 86.5 7 L 3.5 7 C 1.567001342773438 7 0 5.433000087738037 0 3.5 C 0 1.566999912261963 1.567001342773438 0 3.5 0 Z",
    stroke: "none",
    fill: "#4994ec"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_287",
    "data-name": "Rectangle 287",
    transform: "translate(876 711)",
    fill: "none",
    stroke: "#e15241",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 7,
    rx: 3.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 33,
    height: 6,
    rx: 3,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_288",
    "data-name": "Rectangle 288",
    transform: "translate(914 711)",
    fill: "none",
    stroke: "#f6c344",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 90,
    height: 7,
    rx: 3.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 89,
    height: 6,
    rx: 3,
    fill: "none"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKuroLogoFullAlt);
export default __webpack_public_path__ + "static/media/kuroLogoFullAlt.b4209dc472dd1d90786a6be5ffbaf52e.svg";
export { ForwardRef as ReactComponent };